app.factory(
    'MapService', ['$q', MapService]
);
function MapService($q) {

    var myGeo;

    var result = function () {
        return {
            success: false,
            message: '',
            location: {
                latitude: '',
                longitude: ''
            }
        }
    };

    myGeo = {
        getGoogleLocation: function (address) {
            var deferred = $q.defer();

            var googleMap = new google.maps.Geocoder();
            googleMap.geocode({ 'address': address }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {

                    deferred.resolve(results);

                } else {
                    var error = new result();
                    error.message = 'The geocode was not successful for the these reasons: ' + status;

                    deferred.reject(error);

                }

            });

            return deferred.promise;
        },

        getBingLocation: function (address) {
            var deferred = $q.defer();

            var map = new Microsoft.Maps.Map('#bing-map', {
                //credentials: 'AjTmIhmH74-iH27GOlIJHEynrTNFmI0r5bB06AocbR03fjfiDtqv-DdUVD93P6xx'
            });

            Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
                searchManager = new Microsoft.Maps.Search.SearchManager(map);
                var searchRequest = {
                    where: address,
                    callback: function (r) {
                        deferred.resolve(r.results);
                    },
                    errorCallback: function (e) {
                        //If there is an error, alert the user about it.
                        var error = new result();
                        error.message = 'The geocode was not successful for the these reasons: ' + status;

                        deferred.reject(error);
                    }
                };
                //Make the geocode request.
                searchManager.geocode(searchRequest);
            });
            return deferred.promise;
        },

    };

    return myGeo;

}